import React from 'react';
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';

export const getCampaignAutomationOptions = props => {
  const {
    campaignBasicOccurrenceTypeOptions,
    campaignOccurrenceTypeOptions,
    campaignOnDemandOccurrenceTypeOptions,
    campaignStandardOccurrenceTypeOptions,
    isItineraryOnly,
    hasFeatureSurvey,
    hasFeatureOnDemand,
    hasFeatureStandard,
    type,
    currentTemplate
  } = props;
  let options = [];
  if ((!type || type !== 'queryTemplate') && isItineraryOnly) {
    options = campaignBasicOccurrenceTypeOptions;
  } else if (hasFeatureSurvey) {
    options = campaignOccurrenceTypeOptions;
  } else if (hasFeatureOnDemand) {
    options = campaignOnDemandOccurrenceTypeOptions;
  } else if (hasFeatureStandard) {
    options = campaignStandardOccurrenceTypeOptions;
  } else {
    options = campaignBasicOccurrenceTypeOptions;
  }
  if (currentTemplate && currentTemplate._isCopy) {
    options = options.map(option => {
      if (!(option.value === 'ON_EVENT' || option.value === 'SCHEDULED')) {
        return {
          ...option,
          isDisabled: true
        };
      } else {
        return {
          ...option
        };
      }
    })
  }
  return {
    list: options,
    keyId: 'value',
    valueId: 'value',
    displayValueId: 'label'
  };
};

export const getEventTypeOptions = (
  eventTypeOptions,
  includeEventTypeCategory,
  template
) => {
  const safeEventTypeOptions = Array.isArray(eventTypeOptions)
    ? eventTypeOptions
    : [];

  let isOptionEditableForTransient = () => {
    return safeEventTypeOptions.filter(option =>
      (option.productName === template?.productName) &&
      (option.productCategory === template?.productCategory) &&
      (option.eventTypeCategory === template?.eventTypeCategory) &&
      (option.type === 'EVENT_TYPE'))
      .length > 1;
  };
  let getIsDisabled = (option, template) => {
    let disabled = false;
    if(!`${option?.schemaIdentifier}`.includes(`${template?.productCategory}.${template?.productName}.${template?.eventTypeCategory}`)) {
      disabled = true;
    }
    return disabled;
  };
  let options = safeEventTypeOptions.map((option, i) => {
      if (
        option.type === 'PRODUCT_CATEGORY' ||
        option.type === 'PRODUCT_NAME' ||
        (option.type === 'EVENT_TYPE_CATEGORY' && includeEventTypeCategory)
      ) {
        let classMap = {
          PRODUCT_CATEGORY: 'level1',
          PRODUCT_NAME: 'level2',
          EVENT_TYPE_CATEGORY: 'level3'
        };
        return {
          ...option,
          key: option.id + i,
          className: classMap[option.type],
          hasIcon: true,
          iconStyle: { minWidth: '30px' },
          iconElement: <SubdirectoryArrowRightIcon />,
          onClickText: event => {
            event.stopPropagation();
          },
          displayText: option.displayName
        };
      } else {
        return {
          ...option,
          key: option.id + i,
          className: 'level4',
          ...(template && template._isCopy && { isDisabled: getIsDisabled(option, template) || (!option.longTermStorage && !isOptionEditableForTransient()) })
        };
      }
    });
  return {
    list: options || [],
    keyId: 'key',
    valueId: 'id',
    displayValueId: 'displayName'
  };
};
